import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Map, Marker, Polygon, Polyline, GoogleApiWrapper, InfoWindow } from 'google-maps-react';
import myConfig from '../../configs/config';
import ServiceOrderCardEditModal from '../../containers/PendingSchedules/ServiceOrderCardEditModal';
import {
  MAP_VIEWPORT_SCOPES,
  applyViewportToGoogleMap,
  readLocalMapViewport,
  readViewportFromGoogleMap,
  resolveMapViewport,
  writeLocalMapViewport,
} from '../../utils/mapViewport';
import { LAND_PLOT_MAP_STYLE, LAND_PLOT_MAP_STYLE_HIGHLIGHTED } from '../../utils/mapMeasurements';
import { applyGradualMapZoom } from '../../utils/gradualMapZoom';
import {
  formatMapSpeedLabel,
  formatOperatorMapLabel,
  resolveMapIconTone,
} from '../../containers/Dashboard/dashboardIconTone';
import {
  findAssumedOperatorName,
  findEquipmentByIdent,
  getEquipmentPathPoints,
  isMachineAssumed,
  normalizeMachineIdent,
  sameMachineIdent,
  PLATFORM_PEDESTRIAN,
  resolveEquipmentMarkerPosition,
  resolveOperatorMarkerAnchor,
  shouldHideLeftoverColocatedMachine,
  shouldRenderPedestrianMarker,
} from '../../containers/Dashboard/dashboardMapUtils';
import {
  machineIdentTrailShown,
  machineTrailShown,
  operatorShownOnMap,
  peopleTrailDrawList,
} from '../../containers/Dashboard/dashboardTrailPeople';
import {
  selectTrailWork,
  trailSubjectHtml,
  trailWorkNotesHtml,
} from '../../containers/Dashboard/dashboardTrailWork';
import {
  formatGpsUtcDisplay,
  formatTrackSpeed,
  nearestTrackPoint,
  nearestTrailAtClick,
  pointInsideLandplots,
  pointsAreCoLocated,
  splitPathBySpeedColor,
  splitPathByTeleport,
  spreadMarkersSideBySide,
  trackPointHeading,
} from '../../containers/Dashboard/dashboardTraceUtils';
import { formatRelativeTime } from '../../helpers/utils';
import { weatherLoadingHtml, loadWeatherInfoWindowHtml } from '../../containers/FieldApp/fieldAppWeather';
import {
  POINT_DETAILS_INFO_WINDOW_MS,
  pointDetailsInfoWindowHtml,
} from '../../containers/FieldApp/pointDetailsInfoWindow';
import {
  FIELD_APP_TIMEZONE_MODES,
  fieldAppDataTimeZone,
} from '../../containers/FieldApp/fieldAppTimezoneDisplay';

import MapIconColorLegend from './MapIconColorLegend';
import './Marker.css';
import './DashboardTrackPoint.css';

export class MapContainer extends Component {

  constructor(props) {    
    super(props)  
    this.ref = null;  
    this.viewportApplied = false;
    this.savedViewport = readLocalMapViewport(
      MAP_VIEWPORT_SCOPES.DASHBOARD,
      props.farm_id
    );
    this.state = {
      centroidLat: "",
      centroidLng: "",
      //- Azul - Vermelho - Amarelo - Laranja - Roxo - Magenta - Cyano - Ocre - Bordo - Petróleo - Azul naval - Quentão - Rosa           
      colors: ["#031AA5", "#DB0C03", "#F5B002", "#F36924", "#69029B", "#F100F7", "#23A1C6", "#857012", "#740224", "#0F565C", "#040244", "#AE4E46", "#DF1B5F"],
      activeMarker: {},
      selectedPlace: {},
      showPolygonInfoWindow : {},
      showPolygonInfo: false,
      zoom : false,
      mapZoomForOffset: null,
      trailWorkEdit: null,
    }    
    this.map = "";
    this.onMarkerClick = this.onMarkerClick.bind(this);    
  }
  
  handleSaveMapViewport = () => {
    if (!this.map || !this.map.map) return;
    const viewport = readViewportFromGoogleMap(this.map.map);
    writeLocalMapViewport(MAP_VIEWPORT_SCOPES.DASHBOARD, this.props.farm_id, viewport);
    this.savedViewport = viewport;
    this.viewportApplied = true;
    if (this.props.onSaveViewportExtra) {
      this.props.onSaveViewportExtra();
    }
  }

  triggerMapResize = () => {
    if (!this.map || !this.map.map || !this.props.google) return;
    window.setTimeout(() => {
      if (!this.map || !this.map.map || !this.props.google) return;
      this.props.google.maps.event.trigger(this.map.map, "resize");
    }, 80);
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.cleanMode === this.props.cleanMode &&
      prevProps.mapHeight === this.props.mapHeight
    ) {
      return;
    }
    this.triggerMapResize();
  }

  applySavedViewport(map) {
    if (this.viewportApplied || !this.savedViewport || !map) return;
    const viewport = this.savedViewport;
    const lat = Number(viewport.lat);
    const lng = Number(viewport.lng);
    const zoom = Number(viewport.zoom);
    const valid =
      Number.isFinite(lat) &&
      Number.isFinite(lng) &&
      Number.isFinite(zoom) &&
      Math.abs(lat) <= 90 &&
      Math.abs(lng) <= 180 &&
      zoom >= 3 &&
      zoom <= 21;
    if (!valid) {
      this.savedViewport = null;
      return;
    }
    applyViewportToGoogleMap(map, viewport);
    this.viewportApplied = true;
  }

  getFarmFallbackCenter() {
    const farm = this.props.farm || {};
    const centroid = farm.centroid || {};
    let lat = Number(centroid.lat);
    let lng = Number(centroid.lng);

    if (!Number.isFinite(lat) || !Number.isFinite(lng) || (lat === 0 && lng === 0)) {
      lat = Number(farm.latitude);
      lng = Number(farm.longitude);
    }

    if (!Number.isFinite(lat) || !Number.isFinite(lng) || (lat === 0 && lng === 0)) {
      const geo = farm.geo_coords;
      if (Array.isArray(geo) && geo.length >= 2) {
        lat = Number(geo[1]);
        lng = Number(geo[0]);
      } else if (geo && typeof geo === "object") {
        lat = Number(geo.lat != null ? geo.lat : geo.y);
        lng = Number(geo.lng != null ? geo.lng : geo.x);
      }
    }

    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      return { lat: -15.78, lng: -47.93 };
    }

    return { lat, lng };
  }

  getInitialViewport() {
    const farm = this.props.farm || {};
    const fallbackCenter = this.getFarmFallbackCenter();

    return resolveMapViewport({
      apiViewport: farm.map_viewport,
      localViewport: this.savedViewport,
      fallbackCenter,
      fallbackZoom: this.get_boundary(),
    });
  }

  syncZoomForOffset = (mapInstance) => {
    const native = mapInstance || (this.map && this.map.map);
    if (!native || !native.getZoom) return;
    if (this.zoomOffsetTimer) clearTimeout(this.zoomOffsetTimer);
    this.zoomOffsetTimer = setTimeout(() => {
      this.zoomOffsetTimer = null;
      const zoom = native.getZoom();
      if (!Number.isFinite(zoom) || zoom === this.state.mapZoomForOffset) return;
      this.setState({ mapZoomForOffset: zoom });
    }, 160);
  };

  handleZoomChanged = (event) => {
    this.syncZoomForOffset();
    if (this.props.zoomChanged) {
      this.props.zoomChanged(event);
    }
  };

  emitMapCenter = () => {
    if (!this.map || !this.map.map || !this.props.onMapCenterChanged) return;
    const center = this.map.map.getCenter();
    if (!center) return;
    this.props.onMapCenterChanged({
      lat: center.lat(),
      lng: center.lng(),
    });
  };

  onMapReady = (_mapProps, map) => {
    if (!map || !this.props.google) return;
    applyGradualMapZoom(map);
    const maps = this.props.google.maps;
    map.setMapTypeId(maps.MapTypeId.HYBRID);
    this.applySavedViewport(map);
    maps.event.trigger(map, "resize");
    this.syncZoomForOffset(map);
    this.emitMapCenter();
    // dblclick nativo do Google Maps (mais estável que timer em cima do rastro)
    if (this._mapDblClickListener) {
      maps.event.removeListener(this._mapDblClickListener);
    }
    this._mapDblClickListener = map.addListener("dblclick", (event) => {
      this.onMapDblClick(event);
    });
    if (this._mapClickCloseListener) {
      maps.event.removeListener(this._mapClickCloseListener);
    }
    this._mapClickCloseListener = map.addListener("click", () => {
      this.onMapClickCloseTrackPoint();
    });
    // Projeção para achar talhão a partir de pixel do DOM (clique rápido no rastro).
    if (!this._mapProjectionOverlay) {
      this._mapProjectionOverlay = new maps.OverlayView();
      this._mapProjectionOverlay.onAdd = function onAdd() {};
      this._mapProjectionOverlay.draw = function draw() {};
      this._mapProjectionOverlay.onRemove = function onRemove() {};
    }
    this._mapProjectionOverlay.setMap(map);

    const mapDiv = map.getDiv && map.getDiv();
    if (mapDiv && mapDiv !== this._mapDomEl) {
      if (this._mapDomEl) {
        if (this._mapDomDblClick) {
          this._mapDomEl.removeEventListener("dblclick", this._mapDomDblClick, true);
        }
        if (this._mapDomMouseDown) {
          this._mapDomEl.removeEventListener("mousedown", this._mapDomMouseDown, true);
        }
      }
      this._mapDomEl = mapDiv;
      // Clique bem rápido: o Maps às vezes engole os click e só sobra dblclick/mousedown.
      this._mapDomMouseDown = (domEvent) => {
        if (this.props.landplotPickMode || this._landplotToggleLock) return;
        if (domEvent && domEvent.button != null && domEvent.button !== 0) return;
        const now = Date.now();
        const x = domEvent ? domEvent.clientX : 0;
        const y = domEvent ? domEvent.clientY : 0;
        const last = this._rawMapDown;
        this._rawMapDown = { at: now, x, y };
        if (
          !last ||
          now - last.at > MapContainer.LANDPLOT_DOUBLE_CLICK_MS ||
          Math.hypot(x - last.x, y - last.y) > 28
        ) {
          return;
        }
        const plot =
          this.landplotAtDomEvent(domEvent) ||
          (this._lastLandplotTap && this._lastLandplotTap.plot);
        if (!plot) return;
        this.selectLandplotDoubleClick(plot);
      };
      // dblclick do SO pode ser mais lento que 300 ms — só evita zoom; quem marca é o mousedown.
      this._mapDomDblClick = (domEvent) => {
        if (this._landplotToggleLock && domEvent) {
          if (typeof domEvent.preventDefault === "function") {
            domEvent.preventDefault();
          }
          if (typeof domEvent.stopPropagation === "function") {
            domEvent.stopPropagation();
          }
        }
      };
      mapDiv.addEventListener("mousedown", this._mapDomMouseDown, true);
      mapDiv.addEventListener("dblclick", this._mapDomDblClick, true);
    }
    if (this.props.onNativeMapReady) {
      this.props.onNativeMapReady({ map, maps });
    }
    if (this.props.onViewportActionsReady) {
      this.props.onViewportActionsReady({
        save: this.handleSaveMapViewport,
      });
    }
  }

  setTrackPopupLayer = (active) => {
    const wrapper =
      (this.map && this.map.map && this.map.map.getDiv && this.map.map.getDiv()) ||
      document.querySelector(".dashboard-map-wrapper");
    const mapRoot = wrapper && (wrapper.closest(".map-container") || wrapper.parentElement);
    const mapContainer =
      mapRoot && mapRoot.classList && mapRoot.classList.contains("map-container")
        ? mapRoot
        : document.querySelector(".map-container");
    if (mapContainer) {
      mapContainer.classList.toggle("is-track-popup-open", Boolean(active));
    }
    const dashboard = (mapContainer && mapContainer.closest(".dashboard")) ||
      document.querySelector(".dashboard");
    if (dashboard) {
      dashboard.classList.toggle("is-track-popup-open", Boolean(active));
    }
    const bar =
      (mapContainer &&
        mapContainer.previousElementSibling &&
        mapContainer.previousElementSibling.classList &&
        mapContainer.previousElementSibling.classList.contains("dashboard-timezone-bar") &&
        mapContainer.previousElementSibling) ||
      document.querySelector(".dashboard-timezone-bar");
    if (bar) {
      bar.classList.toggle("is-track-popup-open", Boolean(active));
    }
  };

  setTrackPointOffset = (expanded) => {
    if (!this.trackPointInfoWindow || !this.props.google || !this.props.google.maps) {
      return;
    }
    // Empurra o balão ~3cm+ para a área de satélite, abaixo da barra branca.
    this.trackPointInfoWindow.setOptions({
      pixelOffset: new this.props.google.maps.Size(0, expanded ? 230 : 72),
      zIndex: 100002,
    });
  };

  closeTrackPointPopup = () => {
    this.trackPointRequest = (this.trackPointRequest || 0) + 1;
    this._trackPointPinned = false;
    this.setTrackPopupLayer(false);
    if (this.trackPointCloseTimer) {
      clearTimeout(this.trackPointCloseTimer);
      this.trackPointCloseTimer = null;
    }
    if (this.trackPointInfoWindow) {
      this.trackPointInfoWindow.close();
    }
    if (this.trackDirectionMarker) {
      this.trackDirectionMarker.setMap(null);
      this.trackDirectionMarker = null;
    }
  };

  onMapClickCloseTrackPoint = () => {
    if (!this.trackPointInfoWindow) return;
    // Clique no rastro também dispara click no mapa — ignora o eco curto.
    if (
      this._ignoreMapClickCloseUntil &&
      Date.now() < this._ignoreMapClickCloseUntil
    ) {
      return;
    }
    this.closeTrackPointPopup();
  };

  componentWillUnmount() {
    if (this.zoomOffsetTimer) clearTimeout(this.zoomOffsetTimer);
    window.clearTimeout(this._landplotTapTimer);
    this.cancelDeferredTrailOpen();
    if (this._mapDblClickListener && this.props.google) {
      this.props.google.maps.event.removeListener(this._mapDblClickListener);
      this._mapDblClickListener = null;
    }
    if (this._mapClickCloseListener && this.props.google) {
      this.props.google.maps.event.removeListener(this._mapClickCloseListener);
      this._mapClickCloseListener = null;
    }
    if (this._mapDomEl) {
      if (this._mapDomDblClick) {
        this._mapDomEl.removeEventListener("dblclick", this._mapDomDblClick, true);
      }
      if (this._mapDomMouseDown) {
        this._mapDomEl.removeEventListener("mousedown", this._mapDomMouseDown, true);
      }
      this._mapDomDblClick = null;
      this._mapDomMouseDown = null;
      this._mapDomEl = null;
    }
    if (this._mapProjectionOverlay) {
      this._mapProjectionOverlay.setMap(null);
    }
    this.closeTrackPointPopup();
  }

  landplotAtDomEvent(domEvent) {
    if (!domEvent || !this.props.google) return null;
    const overlay = this._mapProjectionOverlay;
    const projection =
      overlay && typeof overlay.getProjection === "function"
        ? overlay.getProjection()
        : null;
    const mapDiv = this._mapDomEl;
    if (!projection || !mapDiv) return null;
    const rect = mapDiv.getBoundingClientRect();
    if (!rect.width || !rect.height) return null;
    const point = new this.props.google.maps.Point(
      domEvent.clientX - rect.left,
      domEvent.clientY - rect.top
    );
    const latLng =
      typeof projection.fromContainerPixelToLatLng === "function"
        ? projection.fromContainerPixelToLatLng(point)
        : null;
    if (!latLng) return null;
    return this.landplotAtPoint({ lat: latLng.lat(), lng: latLng.lng() });
  }

  onMarkerClick(props, marker, e) {
    this.closeTrackPointPopup();
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
      showPolygonInfo : false        
    });
  }  
  
  clickLatLng(event) {
    const latLng = event && event.latLng;
    if (!latLng || typeof latLng.lat !== "function") return null;
    const lat = Number(latLng.lat());
    const lng = Number(latLng.lng());
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    return { lat, lng };
  }

  trailClickZoom() {
    const nativeMap = this.map && this.map.map;
    const zoom =
      nativeMap && typeof nativeMap.getZoom === "function"
        ? nativeMap.getZoom()
        : null;
    return Number.isFinite(zoom) ? zoom : 16;
  }

  resolveTrailClick(event) {
    const click = this.clickLatLng(event);
    if (!click) return null;
    return nearestTrailAtClick(click, this.trailHitTargets, this.trailClickZoom());
  }

  markLandplotToggleLock() {
    this._landplotToggleLock = true;
    window.clearTimeout(this._landplotToggleLockTimer);
    this._landplotToggleLockTimer = window.setTimeout(() => {
      this._landplotToggleLock = false;
    }, 500);
  }

  toggleLandplotFromMap(landplot, options = {}) {
    if (!landplot || typeof this.props.onToggleLandplot !== "function") return;
    this.markLandplotToggleLock();
    this.props.onToggleLandplot(landplot, options);
    this.setState({
      showPolygonInfoWindow: {
        render_marker: true,
        landplot,
        position: landplot.landplot_center,
        markers: null,
      },
    });
  }

  landplotAtPoint(point) {
    if (!point) return null;
    const plots = Array.isArray(this.props.landplot) ? this.props.landplot : [];
    for (let i = 0; i < plots.length; i += 1) {
      const plot = plots[i];
      if (plot && pointInsideLandplots(point, [plot])) return plot;
    }
    return null;
  }

  landplotAtEvent(event) {
    return this.landplotAtPoint(this.clickLatLng(event));
  }

  // Dois cliques no mesmo talhão (qualquer ponto), no máx. 300 ms.
  static LANDPLOT_DOUBLE_CLICK_MS = 300;
  // Atrasa o popup do rastro só o bastante para o 2º clique rápido marcar.
  static LANDPLOT_TRAIL_OPEN_DELAY_MS = 320;

  clickDetail(event) {
    const detail = event && event.domEvent && event.domEvent.detail;
    return Number(detail) || 0;
  }

  cancelDeferredTrailOpen() {
    window.clearTimeout(this._deferredTrailOpenTimer);
    this._deferredTrailOpenTimer = null;
    this._deferredTrailOpenArgs = null;
  }

  scheduleDeferredTrailOpen(args) {
    this.cancelDeferredTrailOpen();
    const latLng = args && args.event && args.event.latLng;
    if (!latLng || !args.props) return;
    this._deferredTrailOpenArgs = {
      props: args.props,
      event: { latLng },
    };
    this._deferredTrailOpenTimer = window.setTimeout(() => {
      const pending = this._deferredTrailOpenArgs;
      this._deferredTrailOpenTimer = null;
      this._deferredTrailOpenArgs = null;
      if (pending) this.openTrailPointPopup(pending);
    }, MapContainer.LANDPLOT_TRAIL_OPEN_DELAY_MS);
  }

  rememberLandplotTap(plot) {
    if (!plot || plot.id == null) return;
    this._lastLandplotTap = {
      id: plot.id,
      at: Date.now(),
      plot,
    };
    window.clearTimeout(this._landplotTapTimer);
    this._landplotTapTimer = window.setTimeout(() => {
      this._lastLandplotTap = null;
      this._landplotTapTimer = null;
    }, MapContainer.LANDPLOT_DOUBLE_CLICK_MS);
  }

  resolveDoubleClickPlot(event, plotFromClick) {
    const last = this._lastLandplotTap;
    let plot = plotFromClick || this.landplotAtEvent(event) || null;
    if (plot && last && Number(plot.id) !== Number(last.id)) {
      return { plot, switched: true };
    }
    if (!plot && last && last.plot) {
      plot = last.plot;
    }
    return { plot, switched: false };
  }

  selectLandplotDoubleClick(plot) {
    if (!plot) return false;
    this.cancelDeferredTrailOpen();
    window.clearTimeout(this._landplotTapTimer);
    this._landplotTapTimer = null;
    this._lastLandplotTap = null;
    this._rawMapDown = null;
    this.closeTrackPointPopup();
    this.toggleLandplotFromMap(plot, { fromDoubleClick: true });
    return true;
  }

  /**
   * 2º clique no mesmo talhão dentro de LANDPLOT_DOUBLE_CLICK_MS (300 ms).
   * detail>=2 só conta se o 1º clique foi há no máximo 300 ms.
   */
  consumeLandplotDoubleClick(event, plotFromClick) {
    if (this.props.landplotPickMode) return false;

    const detail = this.clickDetail(event);
    const resolved = this.resolveDoubleClickPlot(event, plotFromClick);
    const plot = resolved.plot;
    const last = this._lastLandplotTap;
    const withinWindow =
      last &&
      last.at &&
      Date.now() - last.at <= MapContainer.LANDPLOT_DOUBLE_CLICK_MS;

    // detail 2+ só se o intervalo real ainda está na janela de 300 ms.
    if (detail >= 2 && plot && withinWindow) {
      return this.selectLandplotDoubleClick(plot);
    }

    if (!last || last.id == null || !last.at) return false;
    if (!withinWindow) {
      this._lastLandplotTap = null;
      return false;
    }
    if (resolved.switched) {
      this.rememberLandplotTap(plot);
      return false;
    }
    if (!plot || Number(plot.id) !== Number(last.id)) return false;
    return this.selectLandplotDoubleClick(plot);
  }

  // dblclick nativo do SO pode ser mais lento que 300 ms: não marca por aqui.
  onMapDblClick = () => {};

  onPolygonDblClick = () => {};

  onTrailDblClick = () => {};

  onPolygonClick = (props, landplot, e) => {
    const plot = (props && props.landplot) || this.landplotAtEvent(e);

    // Modo Talhão: clique simples no polígono (não abre rastro).
    if (this.props.landplotPickMode) {
      this.cancelDeferredTrailOpen();
      this._lastLandplotTap = null;
      this.closeTrackPointPopup();
      this.toggleLandplotFromMap(plot);
      return;
    }

    // Já marcado via mousedown/dblclick DOM (clique bem rápido).
    if (this._landplotToggleLock) return;

    if (this.consumeLandplotDoubleClick(e, plot)) return;

    if (plot) this.rememberLandplotTap(plot);

    const trail = this.resolveTrailClick(e);
    if (trail) {
      // Não abre na hora: clique rápido no talhão precisa do 2º clique livre.
      this.scheduleDeferredTrailOpen({
        props: {
          path: trail.path,
          strokeColor: trail.strokeColor,
          strokeWeight: trail.strokeWeight,
          trailSubject: trail.trailSubject,
        },
        event: e,
      });
      return;
    }
    this.cancelDeferredTrailOpen();
    this.closeTrackPointPopup();
  };

  handleShowPolygonInfo = (props, marker, e) => {    
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: false,
      showPolygonInfo:true
    });
  }
  

  getRandomColor(i) {
    let color = this.state.colors[i];

    if (i >= this.state.colors.length) {
      color = this.state.colors[Math.round(Math.random(0, this.state.colors.length))];
    }

    return color;
  }

  platformIconUrl(kind, tone) {
    const folder = tone || "offline";
    try {
      return require(`../../assets/platform/${folder}/${kind}.svg`);
    } catch (error) {
      return require(`../../assets/platform/${folder}/machine-empty.svg`);
    }
  }

  machineIconUrl(iconName, tone) {
    const folder = tone || "offline";
    try {
      return require(`../../assets/traccar/${folder}/${iconName}.svg`);
    } catch (error) {
      return require(`../../assets/traccar/${folder}/tractor.svg`);
    }
  }

  markerIconWithLabelAbove(url, width, height) {
    const maps = this.props.google && this.props.google.maps;
    if (!maps || !url) return url;
    return {
      url,
      scaledSize: new maps.Size(width, height),
      anchor: new maps.Point(width / 2, height),
      labelOrigin: new maps.Point(width / 2, -10),
    };
  }


  markerLabel(ident, speed) {
    const speedLabel = formatMapSpeedLabel(speed);
    return {
      text: speedLabel || String(ident || ""),
      color: speedLabel ? "#F5C518" : "white",
      fontWeight: "bold",
      fontSize: speedLabel ? "13px" : "12px",
    };
  }

  operatorMarkerLabel(name, speed) {
    const speedLabel = formatMapSpeedLabel(speed);
    return {
      text: formatOperatorMapLabel(name, speed),
      color: speedLabel ? "#F5C518" : "white",
      fontWeight: "bold",
      fontSize: "12px",
    };
  }

  markerSpread() {
    if (this._markerSpread) return this._markerSpread;
    const entries = [];
    const equipmentList = Object.values(this.props.equipments || {});
    const assumedIdents = this.props.assumedMachineIdents || new Set();

    const operators = Object.values(this.props.operators || {});
    const pairByMachine = {};
    operators.forEach((operator) => {
      const ident = normalizeMachineIdent(
        operator && (operator.assumedMachineIdent || operator.iconMachineIdent)
      );
      if (ident) pairByMachine[ident] = `pair-${operator.id}`;
    });

    equipmentList.forEach((equip, index) => {
      if (shouldHideLeftoverColocatedMachine(equip, this.props.equipments, assumedIdents)) {
        return;
      }
      const resolved = resolveEquipmentMarkerPosition(
        equip,
        this.props.farm,
        index,
        equipmentList.length
      );
      if (!resolved.position) return;
      entries.push({
        key: `machine-${equip.id}`,
        position: resolved.position,
        width: 48,
        height: 40,
        pairId: pairByMachine[normalizeMachineIdent(equip.ident)] || null,
      });
    });

    operators.forEach((operator) => {
      if (!shouldRenderPedestrianMarker(operator)) return;
      const assumedMachine = findEquipmentByIdent(
        this.props.equipments,
        operator.assumedMachineIdent || operator.iconMachineIdent
      );
      const assumedMachinePos = assumedMachine
        ? resolveEquipmentMarkerPosition(assumedMachine).position
        : null;
      const anchor = resolveOperatorMarkerAnchor(operator, assumedMachinePos);
      if (!anchor) return;
      const pairId = assumedMachine ? `pair-${operator.id}` : null;
      const nearMachine =
        assumedMachinePos &&
        (anchor.fromOperatorGps
          ? pointsAreCoLocated(anchor, assumedMachinePos)
          : true);
      entries.push({
        key: `operator-${operator.id}`,
        position: anchor,
        width: 36,
        height: 52,
        pairId,
        stickBeside: Boolean(pairId && nearMachine),
      });
    });

    const placed = spreadMarkersSideBySide(entries, this.currentMapZoom());
    const byKey = {};
    entries.forEach((entry, index) => {
      byKey[entry.key] = placed[index] || entry.position;
    });
    this._markerSpread = byKey;
    return byKey;
  }

  render_markers() {
    let obj = this.props.equipments;
    let markers = [];
    const equipmentList = Object.values(obj || {});
    const assumedIdents = this.props.assumedMachineIdents || new Set();
    const spread = this.markerSpread();

    equipmentList.forEach((equip, index) => {
      if (shouldHideLeftoverColocatedMachine(equip, obj, assumedIdents)) {
        return;
      }
      const iconName = equip.traccar_ico || "tractor";
      const assumed = isMachineAssumed(equip, assumedIdents);
      const assumedOperator = findAssumedOperatorName(this.props.operators, equip.ident);
      const assumedRow = Object.values(this.props.operators || {}).find(
        (operator) =>
          normalizeMachineIdent(operator && operator.assumedMachineIdent) ===
          normalizeMachineIdent(equip.ident)
      );
      const liveSpeed =
        assumedRow && assumedRow.speed != null ? assumedRow.speed : equip.speed;
      const tone = resolveMapIconTone({
        assumed,
        speed: liveSpeed,
        lastMovedAt: equip.lastMovedAt,
        reportedAt: (assumedRow && assumedRow.last_connection) || equip.last_connection,
        assumedAt: assumedRow && assumedRow.assumedAt,
        telemetryReleasedAt: equip.telemetryReleasedAt,
        telemetryPausedAt: equip.telemetryPausedAt,
        fallbackOffline: equip.machine_status === "offline",
      });
      const icon_url = this.machineIconUrl(iconName, tone);
      const gpsAt =
        (assumedRow && assumedRow.last_connection) || equip.last_connection;

      const resolved = resolveEquipmentMarkerPosition(
        equip,
        this.props.farm,
        index,
        equipmentList.length
      );
      const coords = spread[`machine-${equip.id}`] || resolved.position;
      if (!coords) {
        return;
      }

      markers.push(<Marker
        key={`machine-${equip.id}`}
        icon={this.markerIconWithLabelAbove(icon_url, 48, 40)}
        title={equip.ident}
        markerKind="machine"
        speed={liveSpeed}
        last_connection={gpsAt}
        assumed_at={assumedRow && assumedRow.assumedAt}
        operation={equip.operation}
        operator_label={assumedOperator || ""}
        label={this.markerLabel(equip.ident, liveSpeed)}
        extra_inf={equip.extra_inf}
        opacity={resolved.isFallback ? 0.72 : 1}
        zIndex={assumedIdents.has(normalizeMachineIdent(equip.ident)) ? 120 : 10}
        onClick={this.onMarkerClick}
        position={coords}>
      </Marker>);
    });

    return markers;
  }

  currentMapZoom() {
    const live =
      this.map && this.map.map && this.map.map.getZoom && this.map.map.getZoom();
    if (Number.isFinite(live)) return live;
    if (Number.isFinite(this.state.mapZoomForOffset)) {
      return this.state.mapZoomForOffset;
    }
    return 14;
  }

  render_operator_markers() {
    const operators = Object.values(this.props.operators || {});
    const spread = this.markerSpread();
    return operators.map((operator) => {
      if (!shouldRenderPedestrianMarker(operator)) {
        return null;
      }
      const assumedMachine = findEquipmentByIdent(
        this.props.equipments,
        operator.assumedMachineIdent || operator.iconMachineIdent
      );
      const assumedMachinePos = assumedMachine
        ? resolveEquipmentMarkerPosition(assumedMachine).position
        : null;
      const lastKnown = resolveOperatorMarkerAnchor(operator, assumedMachinePos);
      if (!lastKnown) return null;
      const position = spread[`operator-${operator.id}`] || lastKnown;
      const tone = resolveMapIconTone({
        assumed: true,
        speed: operator.speed,
        lastMovedAt: operator.lastMovedAt,
        reportedAt: operator.last_connection,
        assumedAt: operator.assumedAt,
        telemetryReleasedAt: operator.telemetryReleasedAt,
        telemetryPausedAt: operator.telemetryPausedAt,
        fallbackOffline: !operator.online,
      });
      const icon_url = this.platformIconUrl(PLATFORM_PEDESTRIAN, tone);
      const online = tone !== "offline";
      return (
        <Marker
          key={`operator-${operator.id}`}
          icon={this.markerIconWithLabelAbove(icon_url, 36, 52)}
          title={operator.name}
          markerKind="operator"
          speed={operator.speed}
          last_connection={operator.last_connection}
          assumed_at={operator.assumedAt}
          label={this.operatorMarkerLabel(operator.name, operator.speed)}
          opacity={online ? 1 : 0.85}
          zIndex={130}
          onClick={this.onMarkerClick}
          position={position}
        />
      );
    });
  }

  render_polygon_makers(){    
    if(this.state.showPolygonInfoWindow.render_marker === true){      
      return <Marker        
                    opacity={0}                                                
                    title={this.state.showPolygonInfoWindow.landplot.name}                   
                    ref={el=>this.ref = el}
                    onClick={this.handleShowPolygonInfo}
                    label={{ text: this.state.showPolygonInfoWindow.landplot.name, color: 'white', fontWeight: 'bold' }}
                    position={this.state.showPolygonInfoWindow.landplot.landplot_center}/>                                                                                                        
    }
  }

  formatGpsClock(value) {
    const zone =
      this.props.timezoneMode === FIELD_APP_TIMEZONE_MODES.DATA
        ? fieldAppDataTimeZone()
        : undefined;
    return formatGpsUtcDisplay(value, zone);
  }

  render_info() {        
    if(this.state.showPolygonInfo === true){          
      return <InfoWindow marker={this.state.activeMarker} visible={true} onCloseclick={(e) => { this.setState({ showPolygonInfo: false }) }}>
          <div>
            <ul>
              <h5><b>Nome:</b> {this.state.showPolygonInfoWindow.landplot.name}</h5>
              <h5><b>Area:</b> {this.state.showPolygonInfoWindow.landplot.area_h2} ha</h5>
            </ul>
          </div>
      </InfoWindow>;         
    }else{            
      let extra_inf = "";
      
      let operation = this.state.activeMarker.operation !== "" ?
      <h5><b>Operação:</b> {this.state.selectedPlace.operation}</h5> : null

      const operatorLabel = this.state.selectedPlace.operator_label ? (
        <h5><b>Operador:</b> {this.state.selectedPlace.operator_label}</h5>
      ) : null;

      if (this.state.selectedPlace.markerKind === "operator") {
        return <InfoWindow
          marker={this.state.activeMarker}
          visible={true}>
          <div>
            <ul>
              <h5>{this.state.selectedPlace.title}</h5>
              {this.state.selectedPlace.assumed_at ? (
                <h5><b>Assumida em:</b> {this.formatGpsClock(this.state.selectedPlace.assumed_at)}</h5>
              ) : null}
              <h5><b>Última posição GPS:</b> {this.formatGpsClock(this.state.selectedPlace.last_connection)}</h5>
            </ul>
          </div>
        </InfoWindow>
      }

      if (this.state.selectedPlace.extra_inf !== undefined) {
        this.state.selectedPlace.extra_inf.map((info) => {
          extra_inf = <h5><b>{info.label}:</b> {info.value}</h5>
        });
      }

      return <InfoWindow
        marker={this.state.activeMarker}
        visible={true}>
        <div>
          <ul>
            <h5>{this.state.selectedPlace.title}</h5>
            {this.state.selectedPlace.assumed_at ? (
              <h5><b>Assumida em:</b> {this.formatGpsClock(this.state.selectedPlace.assumed_at)}</h5>
            ) : null}
            <h5><b>Última posição GPS:</b> {this.formatGpsClock(this.state.selectedPlace.last_connection)}</h5>
            {operation}
            {operatorLabel}
            {extra_inf}
          </ul>
        </div>
      </InfoWindow>
    }
  }

  scheduleTrackPointClose = (delayMs) => {
    if (this.trackPointCloseTimer) {
      clearTimeout(this.trackPointCloseTimer);
    }
    this.trackPointCloseTimer = setTimeout(() => {
      this.closeTrackPointPopup();
    }, delayMs || POINT_DETAILS_INFO_WINDOW_MS);
  };

  trailClockZone() {
    return this.props.timezoneMode === FIELD_APP_TIMEZONE_MODES.DATA
      ? fieldAppDataTimeZone()
      : undefined;
  }

  onTrackClick = (props, _polyline, event) => {
    const latLng = event && event.latLng;
    const nativeMap = this.map && this.map.map;
    if (!latLng || !nativeMap || !this.props.google) return;

    const plotUnderTrail = this.landplotAtEvent(event);
    if (this.props.landplotPickMode && plotUnderTrail) {
      this.cancelDeferredTrailOpen();
      this._lastLandplotTap = null;
      this.closeTrackPointPopup();
      this.toggleLandplotFromMap(plotUnderTrail);
      return;
    }
    // Já marcado via mousedown/dblclick DOM (clique bem rápido).
    if (this._landplotToggleLock) return;
    // 2º clique rápido no mesmo talhão (mesmo em cima do rastro).
    if (this.consumeLandplotDoubleClick(event, plotUnderTrail)) return;
    if (plotUnderTrail) this.rememberLandplotTap(plotUnderTrail);

    // Em cima de talhão: atrasa o rastro para o 2º clique rápido marcar.
    if (plotUnderTrail) {
      this.scheduleDeferredTrailOpen({ props, event });
      return;
    }
    this.cancelDeferredTrailOpen();
    this.openTrailPointPopup({ props, event });
  };

  openTrailPointPopup = ({ props, event } = {}) => {
    const latLng = event && event.latLng;
    const nativeMap = this.map && this.map.map;
    if (!latLng || !nativeMap || !this.props.google || !props) return;

    const chosen = this.resolveTrailClick(event) || {
      path: props.path,
      strokeColor: props.strokeColor,
      trailSubject: props.trailSubject,
    };
    const path = chosen.path || [];
    const point = nearestTrackPoint(path, {
      lat: latLng.lat(),
      lng: latLng.lng(),
    });
    if (!point) return;

    this.setState({
      showingInfoWindow: false,
      showPolygonInfo: false,
    });

    const maps = this.props.google.maps;
    if (this.trackDirectionMarker) {
      this.trackDirectionMarker.setMap(null);
    }
    const color = chosen.strokeColor || props.strokeColor || "#007BFF";
    this.trackDirectionMarker = new maps.Marker({
      position: { lat: Number(point.lat), lng: Number(point.lng) },
      map: nativeMap,
      zIndex: 1001,
      clickable: false,
      icon: {
        path: maps.SymbolPath.FORWARD_CLOSED_ARROW,
        rotation: trackPointHeading(path, point),
        strokeColor: color,
        fillColor: color,
        scale: 3,
        strokeWeight: 3.5,
        fillOpacity: 0.9,
      },
    });

    const translate = this.props.t || ((text) => text);
    const trail = chosen.trailSubject || props.trailSubject || null;
    const timeZone = this.trailClockZone();
    const subjectHtml = trailSubjectHtml(trail, translate);
    const work = selectTrailWork({
      trail,
      pointTime: point.time,
      serviceOrders: this.props.serviceOrders,
      operations: this.props.trailOperations,
      timeZone,
    });
    this.trailWorkDraft = work.draft;
    const notesHtml = trailWorkNotesHtml({
      trail,
      pointTime: point.time,
      serviceOrders: this.props.serviceOrders,
      operations: this.props.trailOperations,
      timeZone,
      t: translate,
    });

    if (!this.trackPointInfoWindow) {
      this.trackPointInfoWindow = new maps.InfoWindow({
        maxWidth: 340,
        zIndex: 100002,
        pixelOffset: new maps.Size(0, 36),
      });
      this.trackPointInfoWindow.addListener("domready", () => {
        this.bindTrailWorkActions();
        this.enableTrackPointScroll();
      });
      this.trackPointInfoWindow.addListener("closeclick", () => {
        this.setTrackPopupLayer(false);
      });
    }

    const requestId = (this.trackPointRequest = (this.trackPointRequest || 0) + 1);
    const buildContent = (weatherHtml) =>
      pointDetailsInfoWindowHtml({
        t: translate,
        weatherHtml,
        speed: formatTrackSpeed(point.speed),
        timeLabel: point.time ? this.formatGpsClock(point.time) : "",
        relativeTime: point.time ? formatRelativeTime(point.time) : "",
        subjectHtml,
        notesHtml,
      });

    this._trackPointPinned = false;
    this._ignoreMapClickCloseUntil = Date.now() + 400;
    this.setTrackPopupLayer(true);
    this.setTrackPointOffset(false);
    this.trackPointInfoWindow.setContent(buildContent(weatherLoadingHtml()));
    this.trackPointInfoWindow.open(nativeMap, this.trackDirectionMarker);
    // Compacto fecha sozinho; depois do Ver mais / ampliar fica aberto.
    this.scheduleTrackPointClose(POINT_DETAILS_INFO_WINDOW_MS);

    loadWeatherInfoWindowHtml({
      farmId: this.props.farm_id,
      point,
    }).then((weatherHtml) => {
      if (requestId !== this.trackPointRequest || !this.trackPointInfoWindow) return;
      this.trackPointInfoWindow.setContent(buildContent(weatherHtml || ""));
      this.bindTrailWorkActions();
      this.enableTrackPointScroll();
    });
  };

  pinTrackPointPopup = () => {
    this._trackPointPinned = true;
    if (this.trackPointCloseTimer) {
      clearTimeout(this.trackPointCloseTimer);
      this.trackPointCloseTimer = null;
    }
  };

  expandTrackPointPopup = (root) => {
    const pane = root || document.querySelector(".gm-style-iw-d:has(.agri-point-details-iw)");
    const card = pane && pane.querySelector(".agri-point-details-iw");
    if (!card) return;
    this.pinTrackPointPopup();
    this.setTrackPopupLayer(true);
    this.setTrackPointOffset(true);
    card.classList.add("is-expanded");
    const details = card.querySelectorAll(".agri-point-work__details[hidden]");
    details.forEach((node) => node.removeAttribute("hidden"));
    card.querySelectorAll("[data-trail-toggle-details]").forEach((button) => {
      button.setAttribute("aria-expanded", "true");
      const label = button.querySelector(".agri-point-work__more-label");
      const translate = this.props.t || ((text) => text);
      const nextLabel = translate("Ver menos");
      if (label) label.textContent = nextLabel;
      button.setAttribute("title", nextLabel);
      button.setAttribute("aria-label", nextLabel);
    });
    this.refreshTrackPointScroll();
  };

  collapseTrackPointPopup = (card) => {
    if (!card) return;
    card.classList.remove("is-expanded");
    this.setTrackPointOffset(false);
    card.querySelectorAll(".agri-point-work__details").forEach((node) => {
      node.setAttribute("hidden", "");
    });
    this.refreshTrackPointScroll();
  };

  refreshTrackPointScroll = () => {
    this.enableTrackPointScroll();
    window.requestAnimationFrame(() => this.enableTrackPointScroll());
  };

  enableTrackPointScroll = () => {
    const panes = document.querySelectorAll(".gm-style-iw-d");
    panes.forEach((root) => {
      const card = root.querySelector(".agri-point-details-iw");
      if (!card) return;
      const scroll = card.querySelector(".agri-point-details-iw__scroll") || card;
      const expanded = card.classList.contains("is-expanded");
      // Mesmo tamanho de antes; só rola se o conteúdo passar desse teto.
      const maxH = expanded ? "min(85vh, 720px)" : "min(55vh, 380px)";
      const iw = root.closest(".gm-style-iw-c");
      root.style.overflow = "visible";
      root.style.maxHeight = "none";
      if (iw) {
        iw.style.maxHeight = "";
        iw.style.overflow = "";
      }
      scroll.style.overflowY = "auto";
      scroll.style.overflowX = "hidden";
      scroll.style.maxHeight = maxH;
      scroll.style.webkitOverflowScrolling = "touch";
      scroll.style.touchAction = "pan-y";
      if (root.dataset.trackPointScrollBound === "1") return;
      root.dataset.trackPointScrollBound = "1";
      const onWheel = (event) => {
        event.stopPropagation();
        this.pinTrackPointPopup();
        const canScroll = scroll.scrollHeight > scroll.clientHeight + 1;
        if (!canScroll) return;
        const atTop = scroll.scrollTop <= 0 && event.deltaY < 0;
        const atBottom =
          scroll.scrollTop + scroll.clientHeight >= scroll.scrollHeight - 1 &&
          event.deltaY > 0;
        if (!atTop && !atBottom) {
          event.preventDefault();
          scroll.scrollTop += event.deltaY;
        }
      };
      scroll.addEventListener("wheel", onWheel, { passive: false });
      scroll.addEventListener(
        "touchmove",
        (event) => {
          event.stopPropagation();
          this.pinTrackPointPopup();
        },
        { passive: true }
      );
      card.addEventListener("dblclick", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.expandTrackPointPopup(root);
      });
    });
  };

  bindTrailWorkActions = () => {
    const panes = document.querySelectorAll(".gm-style-iw-d");
    panes.forEach((root) => {
      if (root.dataset.trailWorkBound === "1") return;
      if (
        !root.querySelector(
          "[data-trail-view-order], [data-trail-edit-order], [data-trail-create-order], [data-trail-toggle-details]"
        )
      ) {
        return;
      }
      root.dataset.trailWorkBound = "1";
      root.addEventListener("click", this.onTrailWorkActionClick);
    });
  };

  onTrailWorkActionClick = (event) => {
    const button = event.target.closest(
      "[data-trail-view-order], [data-trail-edit-order], [data-trail-create-order], [data-trail-toggle-details]"
    );
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    if (button.hasAttribute("data-trail-toggle-details")) {
      const block = button.closest(".agri-point-work");
      const details = block && block.querySelector(".agri-point-work__details");
      if (!details) return;
      const open = details.hasAttribute("hidden");
      const card = button.closest(".agri-point-details-iw");
      if (open) {
        details.removeAttribute("hidden");
        this.pinTrackPointPopup();
        if (card) {
          card.classList.add("is-expanded");
          this.setTrackPopupLayer(true);
          this.setTrackPointOffset(true);
        }
      } else {
        this.collapseTrackPointPopup(card);
      }
      button.setAttribute("aria-expanded", open ? "true" : "false");
      const label = button.querySelector(".agri-point-work__more-label");
      const translate = this.props.t || ((text) => text);
      const nextLabel = open ? translate("Ver menos") : translate("Ver mais");
      if (label) label.textContent = nextLabel;
      button.setAttribute("title", nextLabel);
      button.setAttribute("aria-label", nextLabel);
      this.refreshTrackPointScroll();
      return;
    }
    const viewId = button.getAttribute("data-trail-view-order");
    if (viewId) {
      window.location.assign(
        `/${this.props.farm_id}/pending-schedules/?obs=${viewId}`
      );
      return;
    }
    if (this.trackPointCloseTimer) {
      clearTimeout(this.trackPointCloseTimer);
    }
    if (button.hasAttribute("data-trail-create-order")) {
      const draft = this.trailWorkDraft || {};
      this.setState({
        trailWorkEdit: {
          creating: true,
          start_date: draft.start,
          end_date: draft.end,
          description: "",
          confirmed: false,
          operation: draft.operationId || null,
          operatorId: draft.operatorId,
          machineIdent: draft.machineIdent || "",
        },
      });
      return;
    }
    const editId = Number(button.getAttribute("data-trail-edit-order"));
    const order = (this.props.serviceOrders || []).find(
      (obs) => Number(obs.id) === editId
    );
    if (!order) return;
    this.setState({ trailWorkEdit: order });
  };

  closeTrailWorkEdit = () => {
    this.setState({ trailWorkEdit: null });
  };

  saveTrailWork = async (payload) => {
    const order = this.state.trailWorkEdit;
    if (!order) return;
    const translate = this.props.t || ((text) => text);
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("client-token")}`,
    };
    if (order.creating) {
      const description = String(payload.description || "").trim();
      if (!description) {
        const error = new Error(translate("Informe o que foi feito."));
        error.response = { data: { detail: translate("Informe o que foi feito.") } };
        throw error;
      }
      const body = {
        farm_id: Number(this.props.farm_id),
        start_date: payload.start_date,
        end_date: payload.end_date,
        description,
      };
      if (order.operation) body.operation = order.operation;
      if (order.operatorId != null && order.operatorId !== "") {
        body.operator_ids = [Number(order.operatorId)];
      }
      if (order.machineIdent) {
        body.service_order_plan = { machine_idents: [order.machineIdent] };
      }
      await axios.post(`${myConfig.API_URL}/observation/`, body, { headers });
      toast.success(translate("Observação adicionada com sucesso!"));
    } else {
      await axios.patch(
        `${myConfig.API_URL}/observation/${order.id}/`,
        payload,
        { headers }
      );
      toast.success(translate("Alterações da ordem foram salvas."));
    }
    this.setState({ trailWorkEdit: null });
    if (typeof this.props.onServiceOrdersChanged === "function") {
      this.props.onServiceOrdersChanged();
    }
  };

  tracePieces(coords, fallbackColor) {
    if (this.props.traceColorMode === "speed") {
      return splitPathBySpeedColor(coords, this.props.traceSpeedKmh);
    }
    return [{ color: fallbackColor, path: coords }];
  }

  pushTracePolylines(lines, keyPrefix, coords, fallbackColor, strokeWeight, trailSubject) {
    this.tracePieces(coords, fallbackColor).forEach((piece, pieceIndex) => {
      if (!piece.path || piece.path.length < 2) return;
      if (!this.trailHitTargets) this.trailHitTargets = [];
      this.trailHitTargets.push({
        path: piece.path,
        strokeColor: piece.color,
        strokeWeight,
        trailSubject,
      });
      lines.push(
        <Polyline
          key={`${keyPrefix}-${piece.color}-${pieceIndex}`}
          path={piece.path}
          strokeColor={piece.color}
          strokeOpacity={0.9}
          strokeWeight={strokeWeight}
          clickable
          zIndex={8}
          trailSubject={trailSubject}
          onClick={this.onTrackClick}
          onDblclick={this.onTrailDblClick}
        />
      );
    });
  }

  assumedOperatorForMachine(target) {
    return Object.values(this.props.operators || {}).find((operator) =>
      sameMachineIdent(operator && operator.assumedMachineIdent, target && target.ident)
    );
  }

  personTraceColor(operatorId) {
    const colors = this.props.operatorTraceColors || {};
    return colors[String(operatorId)] || "";
  }

  machineTraceColor(target, index) {
    const assumed = this.assumedOperatorForMachine(target);
    const chosen = assumed ? this.personTraceColor(assumed.id) : "";
    if (chosen) return chosen;

    const reserved = new Set(
      Object.values(this.props.operatorTraceColors || {}).map((color) =>
        String(color).toUpperCase()
      )
    );
    const palette = this.state.colors;
    for (let step = 0; step < palette.length; step += 1) {
      const color = palette[(index + step) % palette.length];
      if (!reserved.has(String(color).toUpperCase())) return color;
    }
    return this.getRandomColor(index);
  }

  render_lines() {
    let i = 0;
    let lines = [];
    for (let target of Object.values(this.props.equipments)) {
      const machineAllowed =
        this.props.mapTrailMode === "active"
          ? machineTrailShown(
              target && target.ident,
              this.props.operators,
              this.props.visibleTrailOperatorIds
            )
          : machineIdentTrailShown(
              target && target.ident,
              this.props.visibleTrailMachineIdents
            );
      if (!machineAllowed) {
        i++;
        continue;
      }
      const color = this.machineTraceColor(target, i);
      const coords = getEquipmentPathPoints(target);
      if (!coords || coords.length < 2) {
        i++;
        continue;
      }

      splitPathByTeleport(coords).forEach((segment, segmentIndex) => {
        if (!segment || segment.length < 2) return;
        const assumed = this.assumedOperatorForMachine(target);
        this.pushTracePolylines(
          lines,
          `${target.id}-${segmentIndex}`,
          segment,
          color,
          4,
          {
            kind: "machine",
            name: target.ident,
            machineIdent: target.ident,
            operatorId: assumed ? assumed.id : null,
            operatorName: assumed && assumed.name ? assumed.name : "",
          }
        );
      });
      i++;
    }
    return lines;
  }

  operatorTrailSegments(operator) {
    const segments =
      operator && operator.last_posi_segments && operator.last_posi_segments.length
        ? operator.last_posi_segments
        : [((operator && operator.last_posi_point) || []).filter(
            (point) => point && point.lat != null && point.lng != null
          )];
    return segments
      .map((segment) =>
        (segment || []).filter((point) => point && point.lat != null && point.lng != null)
      )
      .filter((segment) => segment.length >= 2);
  }

  drawTrailPath(lines, keyPrefix, coords, color, strokeWeight, trailSubject) {
    splitPathByTeleport(coords).forEach((segment, segmentIndex) => {
      if (!segment || segment.length < 2) return;
      this.pushTracePolylines(
        lines,
        `${keyPrefix}-${segmentIndex}`,
        segment,
        color,
        strokeWeight,
        trailSubject
      );
    });
  }

  renderPeopleTrails() {
    const operators = this.props.operators || {};
    const equipment = this.props.equipments || {};
    const draws = peopleTrailDrawList({
      operators,
      machines: equipment,
      visibleOperatorIds: this.props.visibleTrailOperatorIds,
      visibleMachineIdents: this.props.visibleTrailMachineIdents,
    });
    const lines = [];
    let machineIndex = 0;
    draws.forEach((draw) => {
      const operator =
        draw.operatorId == null
          ? null
          : Object.values(operators).find(
              (item) => String(item && item.id) === String(draw.operatorId)
            ) || null;
      const machine =
        draw.machineId == null
          ? null
          : Object.values(equipment).find(
              (item) => String(item && item.id) === String(draw.machineId)
            ) || null;
      const machineCoords = getEquipmentPathPoints(machine);
      const personSegments = this.operatorTrailSegments(operator);
      const color = operator
        ? this.personTraceColor(operator.id) || this.machineTraceColor(machine || {}, machineIndex)
        : this.machineTraceColor(machine || {}, machineIndex);
      if (machine) machineIndex += 1;

      if (draw.source === "operator") {
        personSegments.forEach((segment, index) => {
          this.drawTrailPath(
            lines,
            `operator-line-${draw.operatorId}-${index}`,
            segment,
            this.personTraceColor(operator && operator.id) || "#F5B002",
            3,
            draw.subject
          );
        });
        return;
      }

      if (machineCoords.length >= 2) {
        this.drawTrailPath(
          lines,
          `trail-${draw.source}-${draw.machineId}`,
          machineCoords,
          color,
          4,
          draw.subject
        );
        return;
      }

      personSegments.forEach((segment, index) => {
        this.drawTrailPath(
          lines,
          `trail-${draw.source}-${draw.operatorId}-${index}`,
          segment,
          color,
          4,
          draw.subject
        );
      });
    });
    return lines;
  }

  render_operator_lines() {
    const lines = [];
    Object.values(this.props.operators || {}).forEach((operator) => {
      if (!operatorShownOnMap(operator.id, this.props.visibleTrailOperatorIds)) return;
      const segments =
        operator.last_posi_segments && operator.last_posi_segments.length
          ? operator.last_posi_segments
          : [
              (operator.last_posi_point || []).filter(
                (point) => point && point.lat != null && point.lng != null
              ),
            ];
      segments.forEach((segment, index) => {
        const coords = (segment || []).filter(
          (point) => point && point.lat != null && point.lng != null
        );
        if (coords.length < 2) return;
        this.pushTracePolylines(
          lines,
          `operator-line-${operator.id}-${index}`,
          coords,
          this.personTraceColor(operator.id) || "#F5B002",
          3,
          {
            kind: "operator",
            name: operator.name,
            machineIdent:
              operator.assumedMachineIdent || operator.iconMachineIdent || "",
            operatorId: operator.id,
            operatorName: operator.name || "",
          }
        );
      });
    });
    return lines;
  }

  render_polygon() {
    if (this.props.landplot !== "") {
      const selectedIds = this.props.selectedLandplotIds || [];
      return this.props.landplot.map(landplot => {
        let geometry = JSON.parse(landplot.geomap);
        let coords = geometry.coordinates[0].map(function (item) {
          return { lat: item[1], lng: item[0] };
        });
        const selected = selectedIds.some(
          (id) => Number(id) === Number(landplot.id)
        );
        const style = selected
          ? LAND_PLOT_MAP_STYLE_HIGHLIGHTED
          : LAND_PLOT_MAP_STYLE;

        return (
          <Polygon
            key={`${landplot.id}-${selected ? "on" : "off"}`}
            paths={coords}
            strokeColor={style.strokeColor}
            strokeWeight={style.strokeWeight}
            strokeOpacity={style.strokeOpacity}
            fillColor={style.fillColor}
            fillOpacity={style.fillOpacity}
            zIndex={selected ? 4 : 1}
            landplot={landplot}
            onClick={this.onPolygonClick}
            onDblclick={this.onPolygonDblClick}
          />
        )
      });
    }
  }

  get_boundary() {
    const GLOBE_WIDTH = 256;
    const farm = this.props.farm || {};
    if (farm.centroid && farm.centroid.angle > 0) {
      let zoom = (Math.round(Math.log(window.innerWidth * 360 / farm.centroid.angle / GLOBE_WIDTH) / Math.LN2) - 2); 
      return zoom > 16 ? 16 : zoom 
    } 
    else {
      return 14
    }
  }
  
  render_map() {
    this._markerSpread = null;
    this.trailHitTargets = [];
    let polygons = this.render_polygon();
    let polygon_marker = this.render_polygon_makers();    
    let markers = this.render_markers();
    let operatorMarkers = this.render_operator_markers();
    const initialViewport = this.getInitialViewport();
    let zoom =
      this.props.mapZoom !== 0 ? this.props.mapZoom : initialViewport.zoom;
    const peopleMode = this.props.mapTrailMode === "people";
    let lines = peopleMode ? this.renderPeopleTrails() : this.render_lines();
    let operatorLines = peopleMode ? [] : this.render_operator_lines();
    let info = this.render_info();    
    let lat = initialViewport.lat;
    let lng = initialViewport.lng;
    let markers_center = this.props.marker_center;
    let bounds = new this.props.google.maps.LatLngBounds();    
        
    if (markers_center.length > 0) {                  
      if (this.map !== "") {                        
        this.map.map.fitBounds(bounds.extend(markers_center[markers_center.length - 1]));
        this.map.map.setZoom(zoom);
      }
    }    

    return (      
      <Map google={this.props.google}        
        ref={(el) => this.map = el}       
        zoom={zoom}            
        initialCenter={{
          lat: lat,
          lng: lng
        }}
        style={{ width: "100%", height: "100%" }}
        containerStyle={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          height: "100%",
        }}
        mapType={"hybrid"}
        mapTypeControl={false}
        fullscreenControl={false}
        zoomControl={false}
        disableDoubleClickZoom
        gestureHandling="greedy"
        onZoom_changed={this.handleZoomChanged}
        onDragend={this.emitMapCenter}
        onIdle={this.emitMapCenter}
        onReady={this.onMapReady}
      >        
        {polygons}
        {polygon_marker}
        {operatorLines}
        {lines}
        {markers}
        {operatorMarkers}
        {info}
      </Map>
    );
  }


  render() {
    let map = "";

    map = this.render_map()    

    return (
      <div className="dashboard-map-wrapper">
        {map}
        {this.props.showIconLegend !== false ? (
          <MapIconColorLegend placement="top" />
        ) : null}
        <ServiceOrderCardEditModal
          show={Boolean(this.state.trailWorkEdit)}
          obs={this.state.trailWorkEdit}
          onHide={this.closeTrailWorkEdit}
          onSave={this.saveTrailWork}
          t={this.props.t || ((text) => text)}
          dialogTitle={(this.props.t || ((text) => text))("Editar trabalho")}
          notesLabel={(this.props.t || ((text) => text))("O que foi feito")}
        />
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: (myConfig.GOOGLE_API_KEY),
  libraries:['drawing','places'],
  version: '3.64'
})(MapContainer)
